const stripHTML = str => str && str.replace(/<\/?[^>]+(>|$)/g, '')

export default stripHTML
